import type { ContactSummaryDto } from '@fluenceur/types';

export const getCanonicalConversationId = (
  summary: Pick<ContactSummaryDto, 'conversation' | 'activeIgConversationId'>
): string | null => summary.conversation?.conversationId ?? summary.activeIgConversationId ?? null;
